var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19_153)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.98527 2.60522L10.3973 4.01655M9.89327 1.36188L6.07527 5.17989C5.878 5.37688 5.74345 5.62787 5.6886 5.90122L5.33594 7.66655L7.10127 7.31322C7.3746 7.25855 7.62527 7.12455 7.8226 6.92722L11.6406 3.10922C11.7553 2.99449 11.8463 2.85828 11.9084 2.70838C11.9705 2.55847 12.0025 2.39781 12.0025 2.23555C12.0025 2.0733 11.9705 1.91263 11.9084 1.76273C11.8463 1.61282 11.7553 1.47662 11.6406 1.36188C11.5259 1.24715 11.3897 1.15614 11.2398 1.09405C11.0899 1.03196 10.9292 1 10.7669 1C10.6047 1 10.444 1.03196 10.2941 1.09405C10.1442 1.15614 10.008 1.24715 9.89327 1.36188Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.668 8.9987V10.9987C10.668 11.3523 10.5275 11.6915 10.2774 11.9415C10.0274 12.1916 9.68826 12.332 9.33464 12.332H2.0013C1.64768 12.332 1.30854 12.1916 1.05849 11.9415C0.808444 11.6915 0.667969 11.3523 0.667969 10.9987V3.66536C0.667969 3.31174 0.808444 2.9726 1.05849 2.72256C1.30854 2.47251 1.64768 2.33203 2.0013 2.33203H4.0013",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19_153"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.c6d22b22a745dc7218c3c737c3353ef5.svg";
export { ForwardRef as ReactComponent };